import React, { useEffect, useState, useRef } from 'react'
import no from '../../Assets/Images/Login/no.svg'
import './precioProducto.css'
import Modal from 'react-bootstrap/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { useSelector, useDispatch } from 'react-redux'
import { cotizacionPriceChange } from '../../redux/actions/cotizacionActions'
import { setDiscount } from '../../redux/actions/cartActions'
import { FormatMoney, getMarginTotal } from 'Utils/functions'
import { NumericFormat } from 'react-number-format'
import { getRazonesPrecioAction } from 'redux/actions/clientsActions'
import { t } from 'i18next'
import { toTestId } from 'Utils/Helpers/toTestId'

const MAX_PRICE = 999999

const PrecioProducto = ({
  handleModalEditPrice,
  setProductChangeValidation,
  handleModalSuccesUpdatePrecio,
  product,
  setNuevoPrecio,
  productsRef,
}) => {
  const [maxDiscount, setMaxDiscount] = useState(null)
  const [maxMargin, setMaxMargin] = useState(null)
  const [marginError, setMarginError] = useState(null)
  const [, setNewPerct] = useState(0)
  // const [showMoneyButton, setShowMoneyButton] = useState(true)
  const [anularMargen, setAnularMargen] = useState(false)

  const dispatchCotizacion = useDispatch()

  // Precio Negociacion
  const [precioNegociacion, setPrecioNegociacion] = useState(true)
  // Box Mostrar Razones
  const [mostrarRazones, setMostrarRazones] = useState(false)
  // Razon Precio
  const [razonPrecio, setRazonPrecio] = useState({
    NegotiatedPriceBy: useSelector(
      state => state?.login?.user?.CustomerInfo?.CustomerId
    ),
    NegotiatedPriceByName: useSelector(
      state => state?.login?.user?.AuthenticationInfo?.UserName
    ),
    NegotiatedReason: null,
    NegotiatedReasonCode: null,
    NegotiatedReasonId: null,
    Price: parseFloat(product.Price),
    FinalPrice: parseFloat(product.FinalPrice),
    BasePrice: parseFloat(product.BasePrice),
    Amount: FormatMoney(product.Amount, false, 6),
    DiscountAmount: FormatMoney(product.DiscountAmount, false, 6),
    DiscountAmountLocal: FormatMoney(product.DiscountAmount, false, 6),
    AmountWithTax: FormatMoney(product.AmountWithTax, false, 6),
    // FirstPriceBase : parseFloat(product.BasePrice),
    // FirstDiscountAmount: parseFloat(product.DiscountAmount)
  })

  // List Razones
  const [razones, setRazones] = useState([])
  // Terminar cambio precio por razon

  const [razonSelect, setRazonSelect] = useState(null)

  // Handle Mostrar Razones
  const handleMostrarRazones = () => {
    setMostrarRazones(!mostrarRazones)
  }

  const channelRef = useRef(null)
  if (!channelRef.current) {
    channelRef.current = new BroadcastChannel('customer_display')
  }
  const channel = channelRef.current

  // const handlePriceButton = () => {
  //   setShowMoneyButton(!showMoneyButton)
  // }

  // Handel State
  const handleChange = value => {
    value = value.replace(/,/g, '')
    if (!precioNegociacion) {
      value =
        ((100 - parseFloat(value)) *
          (product.FinalPrice - product.DiscountAmount)) /
        100
    }
    const tempAmountWithTax =
      parseFloat(value) * product.Quantity * (1 + product.TaxCategoryValue)
    const tax = parseFloat(value) * product.TaxCategoryValue * product.Quantity
    setRazonPrecio(prevState => ({
      ...prevState,
      Price: parseFloat(value),
      Amount: parseFloat(value) * product.Quantity,
      AmountWithTax: tempAmountWithTax,
      Tax: tax,
    }))
  }

  const reasonDefault = razones.filter(
    r => r.ReasonId === 'D9C0EFFB-09F6-481B-ABDD-8B8D05081DF1'
  )
  const handleRazon = razon => {
    setRazonSelect(razon)
    setRazonPrecio(prevState => ({
      ...prevState,
      NegotiatedReason: razon.Name,
      NegotiatedReasonCode: razon.Code,
      NegotiatedReasonId: razon.ReasonId,
    }))
  }

  // Handle Check Precio Negociacion
  const handleChangeCheck = () => {
    setPrecioNegociacion(!precioNegociacion)
  }

  // Obtener Razones Precio
  const fetchRazonesPrecio = async () => {
    const payload = {
      reasonTypeId: 'CDD84712-0748-49DC-A58C-608470D04EDC',
      pageSize: 1000,
      pageNumber: 1,
    }
    const Data = await dispatchCotizacion(getRazonesPrecioAction(payload))
    if (Data && Data?.length > 0) {
      setRazones(Data)
    } else {
      throw new Error(Data)
    }
  }

  const cambiarPrecio = async (e, overridePrice = false) => {
    if (isNaN(razonPrecio.Price) || parseFloat(razonPrecio.Price) <= 0) {
      setMarginError('ErrPriceTitle')
      return
    }

    if (parseFloat(razonPrecio.Price) > MAX_PRICE) {
      setMarginError(
        `Error en el precio: límite excedido. El máximo permitido es: ${MAX_PRICE}`
      )
      return
    }

    if (razonPrecio.Price <= maxDiscount && !razonPrecio.NegotiatedReason) {
      handleMostrarRazones()
    } else {
      const newMargin = getMarginTotal(
        razonPrecio.Price,
        product.Cost || product.AvgCost || 0.0,
        product.Quantity
      )
      setNewPerct(newMargin)
      if (razonPrecio.Price >= maxDiscount || overridePrice) {
        razonPrecio.NegotiatedReason = reasonDefault[0]?.Name
        razonPrecio.NegotiatedReasonCode = reasonDefault[0]?.Code
        razonPrecio.NegotiatedReasonId = reasonDefault[0]?.ReasonId
        setNuevoPrecio(razonPrecio)
        // check if setProductChangeValidation is set
        if (setProductChangeValidation) {
          setProductChangeValidation(true)
        }
        handleModalEditPrice()
        handleModalSuccesUpdatePrecio()
        const modifiedProduct = {
          ...product,
          ...razonPrecio,
          Margin: newMargin,
          Price: razonPrecio.Price,
        }
        if (razonPrecio.Price < modifiedProduct.BasePrice) {
          const discount = modifiedProduct.BasePrice - modifiedProduct.Price
          modifiedProduct.DiscountAmount = discount
          modifiedProduct.DiscountAmountLocal = discount
          modifiedProduct.descuento = discount
        } else {
          // set discounts to 0
          modifiedProduct.DiscountAmount = 0
          modifiedProduct.DiscountAmountLocal = 0
          modifiedProduct.DiscountPct = 0
          modifiedProduct.descuento = 0
        }
        const payload = {
          product: modifiedProduct,
        }
        dispatchCotizacion(setDiscount(payload))
        dispatchCotizacion(cotizacionPriceChange(razonPrecio))
        channel.postMessage({
          priceChange: {
            Price: razonPrecio.Price,
            ProductId: modifiedProduct.ProductId,
          },
        })
      } else {
        setMarginError(
          `Precio fuera del margen permitido por ${(
            newMargin - maxMargin
          ).toFixed(2)}%`
        )
        setAnularMargen(true)
      }
    }
  }

  useEffect(() => {
    fetchRazonesPrecio()
    setMaxDiscount(product.FinalPrice)
    setMaxMargin(product.DiscountPct)
  }, [])

  return (
    <>
      <div className="modal-box-update-precio" data-testid="modal-price-change">
        <div className="edit-precio-modal-container">
          <div className="edit-precio-modal-header">
            <h2>Solicitud de cambio de precios</h2>
            <span
              onClick={handleModalEditPrice}
              className="close-modal"
              data-testid="modal-close-price-button">
              <img src={no} alt="close" />
            </span>
          </div>
          <div className="edit-precio-modal-body">
            <p>Precio inicial ${product?.FinalPrice}</p>
            <button
              className="razones-button"
              onClick={handleMostrarRazones}
              data-testid="btn-select-reason">
              Selecciona código de razón
            </button>
            <div className="toggle">
              <p>
                <span>{precioNegociacion ? 'Precio ' : 'Porcentaje '}</span>de
                negociación
              </p>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={precioNegociacion}
                  name="precioNegociacion"
                  value={razonPrecio.precioNuevo}
                  onChange={handleChangeCheck}
                  data-testid="switch-negotiation-type"
                />
                <span className="slider round"></span>
              </label>
            </div>
            <div className="currency-input">
              {precioNegociacion ? (
                <button className="price-sign">$</button>
              ) : (
                <button className="price-sign">%</button>
              )}
              <NumericFormat
                thousandSeparator={true}
                decimalSeparator={'.'}
                decimalScale={4}
                name="precioNuevo"
                id="precioNuevo"
                onChange={event => handleChange(event.target.value)}
                placeholder="Introduce el nuevo precio"
                data-testid="input-price"
              />
            </div>
          </div>
          {marginError && (
            <p
              className="margin-error-message"
              data-testid="margin-error-message">
              {t(marginError)}
            </p>
          )}
          <div className="modal-buttons">
            <button
              className="btn-cambiar"
              onClick={cambiarPrecio}
              data-testid="btn-change-price">
              Cambiar precio
            </button>
          </div>
        </div>
      </div>

      {/* Mostrar Razones de Cambio de Precio */}
      <Modal
        show={anularMargen}
        container={productsRef?.current ? productsRef.current : null}
        backdrop={false}
        className="modal-clase-price-change"
        centered
        data-testid="modal-reasons-price-change">
        <div className="modal-price-change-allow">
          <span
            onClick={() => setAnularMargen(false)}
            className="close-modal"
            data-testid="btn-close-margin-confirmation-modal">
            <img src={no} alt="close" />
          </span>
          <div className="price-allow-text">
            <h2>El precio esta debajo del margen permitido</h2>
            <h2>¿Deseas continuar?</h2>
          </div>
          <div className="price-allow-buttons">
            <button
              className="price-allow-true"
              onClick={(e, overridePrice = true) =>
                cambiarPrecio(e, overridePrice)
              }
              data-testid="btn-margin-confirm-yes">
              Si
            </button>
            <button
              className="price-allow-false"
              onClick={() => setAnularMargen(false)}
              data-testid="btn-margin-confirm-no">
              No
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        show={mostrarRazones}
        // container={productsRef?.current ? productsRef.current : null}
        backdrop={false}
        className="modal-clase-price-change"
        centered
        data-testid="modal-reason-selection">
        <div className="modal-box-update-razones">
          <div className="razones-modal-container">
            <div className="razones-modal-header">
              <h2>Código de razón</h2>
              <span
                onClick={handleMostrarRazones}
                className="close-modal"
                data-testid="btn-close-reason-modal">
                <img src={no} alt="close" />
              </span>
            </div>
            <div className="razones-modal-body">
              {razones.length > 0 &&
                razones.map(razon => {
                  return (
                    <li
                      key={razon?.ReasonId}
                      className={
                        razonSelect?.ReasonId === razon?.ReasonId
                          ? 'razones-option razon-selected'
                          : 'razones-option'
                      }
                      data-testid={`li-reason-option-${toTestId(
                        razon?.ReasonId
                      )}`}>
                      <div className="razon-text">
                        <label htmlFor={razon.ReasonId}>{razon.Name}</label>
                        <p>{razon.Description}</p>
                      </div>
                      <div className="razones-options-buttons">
                        {razonSelect?.ReasonId === razon?.ReasonId ? (
                          <FontAwesomeIcon icon={faCheck} />
                        ) : (
                          <input
                            type="radio"
                            id={razon.ReasonId}
                            name="price-change"
                            value={razon.ReasonId}
                            onClick={() => handleRazon(razon)}
                            data-testid={`input-reason-option-${toTestId(
                              razon.ReasonId
                            )}`}
                          />
                        )}
                      </div>
                    </li>
                  )
                })}
              <div className="modal-buttons">
                <button
                  className="btn-continuar"
                  onClick={handleMostrarRazones}
                  data-testid="btn-reason-continue">
                  Continuar
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default PrecioProducto
